export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  // Только по границе сегмента: иначе `/wms/delivery` подсвечивался
  // и на `/wms/delivery-active`.
  const base = url.endsWith('/') ? url : `${url}/`
  if (current.startsWith(base)) {
    return true
  }

  return false
}
